/* Candidate only. Observed paid visit, never platform attribution. No ad events. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.DepthChatGPTTouch = factory(root);
})(typeof window === 'undefined' ? null : window, function (w) {
  'use strict';
  var KEY = '__depth_chatgpt_touch_v1';
  var STORE = 'depth_chatgpt_touch_v1';
  var DIRTY = 'depth_chatgpt_touch_needs_cleanup_v1';
  var MAX_AGE = 24 * 60 * 60 * 1000;
  var record = null, activeAdds = [], cleaning = null, rerunCleanup = false;
  function permitted() {
    try {
      var p = w.Shopify.customerPrivacy;
      return p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true;
    } catch (_) { return false; }
  }
  function identifier(value, prefix) {
    return typeof value === 'string' && new RegExp('^' + prefix + '_[a-zA-Z0-9]{8,80}$').test(value) ? value : null;
  }
  function valid(r) {
    return r && r.version === 1 && r.basis === 'observed_paid_visit' &&
      identifier(r.campaign_id, 'cmpn') && identifier(r.ad_id, 'ad') &&
      Number.isFinite(r.observed_at_ms) && r.observed_at_ms <= Date.now() &&
      Date.now() - r.observed_at_ms < MAX_AGE;
  }
  function capture() {
    if (!permitted()) {
      record = null;
      try { w.sessionStorage.removeItem(STORE); } catch (_) {}
      return null;
    }
    var q = new URL(w.location.href).searchParams;
    // Organic ChatGPT referrals, QA tags and unresolved macros do not qualify.
    var campaign = identifier(q.get('campaign_id') || q.get('utm_campaign'), 'cmpn');
    var ad = identifier(q.get('ad_id') || q.get('utm_content'), 'ad');
    if (q.get('utm_source') === 'chatgpt' && q.get('utm_medium') === 'paid' && campaign && ad) {
      if (!record || record.campaign_id !== campaign || record.ad_id !== ad) {
        record = {version: 1, basis: 'observed_paid_visit', campaign_id: campaign,
          ad_id: ad, observed_at_ms: Date.now()};
        var group = identifier(q.get('ad_group_id'), 'adg');
        if (group) record.ad_group_id = group;
        // No email, phone, IP, name, full URL, referrer or click token is stored.
        try {
          w.sessionStorage.setItem(STORE, JSON.stringify(record));
          if (w.sessionStorage.getItem(STORE) !== JSON.stringify(record)) record = null;
        } catch (_) { record = null; }
      }
    } else if (!record) {
      try {
        var old = JSON.parse(w.sessionStorage.getItem(STORE));
        if (valid(old)) {
          record = {version: 1, basis: 'observed_paid_visit', campaign_id: old.campaign_id,
            ad_id: old.ad_id, observed_at_ms: old.observed_at_ms};
          if (identifier(old.ad_group_id, 'adg')) record.ad_group_id = old.ad_group_id;
        }
      } catch (_) {}
    }
    if (!valid(record)) record = null;
    return record;
  }
  function dirty() {
    try { return w.sessionStorage.getItem(DIRTY) === '1'; } catch (_) { return false; }
  }
  function markDirty() {
    try { w.sessionStorage.setItem(DIRTY, '1'); return dirty(); } catch (_) { return false; }
  }
  function route(path) {
    var root = w.Shopify && w.Shopify.routes && w.Shopify.routes.root || '/';
    if (!/^\/(?!\/)[A-Za-z0-9/-]*\/$/.test(root) && root !== '/') root = '/';
    return root + path;
  }
  function options(body) {
    return {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)};
  }
  // No preliminary fetch, timer or awaited tracking task: metadata travels with
  // the product in the ONE normal add request. Return its unmodified response.
  function add(items) {
    var touch = capture(), marker = touch && markDirty() ? JSON.stringify(touch) : null;
    var body = {items: items.map(function(item) {
      var copy = Object.assign({}, item);
      copy.properties = Object.assign({}, item.properties || {});
      delete copy.properties[KEY];
      if (marker) copy.properties[KEY] = marker;
      if (!Object.keys(copy.properties).length) delete copy.properties;
      return copy;
    })};
    var request;
    try { request = Promise.resolve(w.fetch(route('cart/add.js'), options(body))); }
    catch (error) { request = Promise.reject(error); }
    activeAdds.push(request);
    function finished() {
      activeAdds = activeAdds.filter(function(p) { return p !== request; });
      if (!permitted() || !valid(touch)) sync();
    }
    request.then(finished, finished);
    return request;
  }
  function keep(value) {
    try { return permitted() && valid(JSON.parse(value)); } catch (_) { return false; }
  }
  // Background cleanup only. It never gates the buy request. Wait for already
  // running adds before removing markers, so late adds cannot restore them.
  function sync() {
    capture();
    if (record) markDirty();
    if (!dirty()) return Promise.resolve(false);
    if (cleaning) { rerunCleanup = true; return cleaning; }
    cleaning = Promise.all(activeAdds.map(function(p) { return p.catch(function() {}); }))
      .then(function() { return w.fetch(route('cart.js'), {credentials:'same-origin',headers:{Accept:'application/json'}}); })
      .then(function(r) { if (!r.ok) throw new Error('cart unavailable'); return r.json(); })
      .then(function(cart) {
        var chain = Promise.resolve();
        (cart.items || []).forEach(function(item) {
          var value = item.properties && item.properties[KEY];
          if (value && !keep(value)) chain = chain.then(function() {
            // Keep every other property. Blank our key: Shopify disallows an
            // empty properties object, and removing/readding would alter cart.
            var properties = Object.assign({}, item.properties); properties[KEY] = '';
            return w.fetch(route('cart/change.js'), options({id:item.key,properties:properties}))
              .then(function(r) { if (!r.ok) throw new Error('cleanup failed'); });
          });
        });
        // Legacy permalink attributes are private and not returned by cart.js.
        // Clear ours on withdrawal/expiry without touching other cart attributes.
        chain = chain.then(function() {
          var current = capture();
          var attrs = {}; attrs[KEY] = current && markDirty() ? JSON.stringify(current) : '';
          return w.fetch(route('cart/update.js'), options({attributes:attrs}))
            .then(function(r) { if (!r.ok) throw new Error('cleanup failed'); });
        });
        return chain.then(function() { return true; });
      }).catch(function() { return false; }).finally(function() { cleaning = null; if (rerunCleanup) { rerunCleanup = false; return sync(); } });
    return cleaning;
  }
  function cartLink(url) {
    var r = capture();
    if (!r) return url;
    var parsed = new URL(url, w.location.origin);
    if (parsed.origin !== w.location.origin || !/^\/cart\/\d+:\d+$/.test(parsed.pathname) || !markDirty()) return url;
    parsed.searchParams.set('attributes[' + KEY + ']', JSON.stringify(r));
    return parsed.pathname + parsed.search;
  }
  if (w.document) w.document.addEventListener('visitorConsentCollected', function() { capture(); sync(); });
  if (w.Shopify && w.Shopify.loadFeatures) {
    w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function(error) { if (!error) { capture(); sync(); } });
  }
  if (w.Shopify && w.Shopify.customerPrivacy) { capture(); sync(); }
  return {add:add,sync:sync,cartLink:cartLink,capture:capture,key:KEY};
});
